import React from 'react';
import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';
import PropTypes from 'prop-types';
import Flex from '../Flex/Flex';
import Bullet from '../Bullet/Bullet';

const statusColors = {
  PAID: theme.oldColors.teal,
  TO_BE_PAID: theme.oldColors.blue,
  ESTIMATED: theme.oldColors.orange,
  HOLIDAY: theme.oldColors.red,
};

const CalendarItem = ({ state, day, text, status }) => {
  const bulletColor = statusColors[status] ? statusColors[status]['100'] : '';
  return (
    <Container
      column
      state={state}
      status={status}
      data-testid='calendar-item-data-test-id'
    >
      <Flex>
        <DayText>{day}</DayText>
        <Bullet color={bulletColor} />
      </Flex>
      <Content state={state}>{text}</Content>
    </Container>
  );
};

CalendarItem.propTypes = {
  day: PropTypes.string,
  text: PropTypes.string,
  state: PropTypes.oneOf(['PAST', 'PREVIOUS', 'NEXT', 'FUTURE']),
  status: PropTypes.oneOf(['PAID', 'TO_BE_PAID', 'ESTIMATED', 'HOLIDAY']),
};

const Container = styled(Flex)`
  height: 100px;
  flex: 1;
  padding: 10px 10px 25px 15px;
  border: 1px solid;
  border-color: #e5e5e5;
  min-width: 230px;

  ${(prop) =>
    prop.state === 'past' &&
    css`
      background-color: ${theme.oldColors.grey[300]};
    `}

  ${(prop) =>
    (prop.state === 'previous' || prop.state === 'next') &&
    prop.status !== 'HOLIDAY' &&
    css`
      background-image: ${statusColors[prop.status]['200']};
    `}

  ${(prop) =>
    prop.state === 'future' &&
    css`
      background-color: ${theme.oldColors.white[500]};
    `}
`;

const DayText = styled.span`
  font-size: 16px;
  color: ${theme.oldColors.grey[500]};
`;

const Content = styled.span`
  font-size: 16px;
  margin-top: auto;
  color: ${theme.oldColors.black[500]};
`;

export default CalendarItem;
